<template>
  <div class="gx-as">
    <div class="gx-as__filter custom-form-wrap">
      <el-form inline size="mini">
        <el-form-item label="店铺分组：">
          <el-select
            class="w290"
            v-model="searchData.group_ids"
            placeholder="全部分组"
            clearable
            multiple
            collapse-tags
            filterable
            @change="onGroupChange"
          >
            <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="店铺名：">
          <el-select class="w290" v-model="searchData.shop_id" placeholder="请选择" clearable filterable>
            <el-option v-for="item in arrShop" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id" />
          </el-select>
        </el-form-item>
        <el-form-item label="售后类型：">
          <el-select class="w290" v-model="searchData.aftersale_type" placeholder="请选择" clearable @change="onTypeChange">
            <el-option v-for="item in arrAftersaleType" :key="item.val" :label="item.text" :value="item.val" />
          </el-select>
        </el-form-item>
        <el-form-item label="售后状态：">
          <el-select class="w290" v-model="searchData.aftersale_status" placeholder="请选择" clearable>
            <el-option v-for="item in arrStatus" :key="item.val" :label="item.text" :value="item.val" />
          </el-select>
        </el-form-item>
        <el-form-item label="申请原因：">
          <el-select class="w290" v-model="searchData.reason_text" placeholder="请选择" clearable filterable>
            <el-option v-for="item in arrApplyReason" :key="item" :label="item" :value="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="商品ID：">
          <el-input class="w290" v-model="searchData.product_id" placeholder="请输入商品ID" clearable />
        </el-form-item>
        <el-form-item label="售后编号：">
          <el-input class="w290" v-model="searchData.wx_after_sale_id" placeholder="请输入微信售后编号" clearable />
        </el-form-item>
        <el-form-item label="订单编号：">
          <el-input class="w290" v-model="searchData.wx_order_id" placeholder="请输入微店订单号" clearable />
        </el-form-item>
        <el-form-item label="订单物流单号：">
          <el-input
            class="w290"
            v-model="searchData.order_express_no"
            placeholder="请输入订单物流单号"
            clearable
            :disabled="!isFilterEnabled('order_express_no')"
            :title="filterDisabledTitle('order_express_no')"
          />
        </el-form-item>
        <el-form-item label="退货物流单号：">
          <el-input class="w290" v-model="searchData.return_logistics_code" placeholder="请输入退货物流单号" clearable />
        </el-form-item>
        <el-form-item label="换货物流单号：">
          <el-input
            class="w290"
            v-model="searchData.exchange_logistics_code"
            placeholder="请输入换货物流单号"
            clearable
          />
        </el-form-item>
        <el-form-item label="日期范围：">
          <el-date-picker
            class="w290"
            v-model="searchData.search_date"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            :default-time="['00:00:00', '23:59:59']"
          />
        </el-form-item>
        <el-form-item label="临期待处理：">
          <el-select
            class="w120"
            v-model="searchData.in_deadline"
            placeholder="请选择"
            clearable
            :disabled="!isFilterEnabled('in_deadline')"
            :title="filterDisabledTitle('in_deadline')"
          >
            <el-option v-for="item in inDeadlineOptions" :key="item.val" :label="item.text" :value="item.val" />
          </el-select>
        </el-form-item>
        <el-form-item label="处理不一致：">
          <el-select
            class="w290"
            v-model="searchData.diff_deal_state"
            placeholder="请选择"
            clearable
            :disabled="!isFilterEnabled('diff_deal_state')"
            :title="filterDisabledTitle('diff_deal_state')"
          >
            <el-option v-for="item in diffDealStateOptions" :key="item.val" :label="item.text" :value="item.val" />
          </el-select>
        </el-form-item>
        <el-form-item label="1688售后状态：">
          <el-select
            class="w290"
            v-model="searchData.alibaba_refund_status"
            placeholder="请选择"
            clearable
            :disabled="!isFilterEnabled('alibaba_refund_status')"
            :title="filterDisabledTitle('alibaba_refund_status')"
          >
            <el-option v-for="item in arrAlibabaRefundStatus" :key="item.val" :label="item.text" :value="item.val" />
          </el-select>
        </el-form-item>
        <el-form-item label="" style="margin-left: auto;">
          <button type="button" class="gx-as__filter-btn gx-as__filter-btn--primary" @click="getList()">查询</button>
          <button type="button" class="gx-as__filter-btn" @click="resetSearch">重置</button>
        </el-form-item>
      </el-form>
    </div>

    <div class="gx-as__card">
      <div class="gx-as__status-tabs">
        <button
          v-for="s in arrTabList"
          :key="s.val"
          class="gx-as__status-tab"
          :class="{ 'gx-as__status-tab--on': String(searchData.tab_value) === String(s.val) }"
          @click="onTabChange(s.val)"
        >
          {{ s.text }}<span v-if="tabBadgeCount(s) > 0" class="gx-as__status-num">{{ tabBadgeCount(s) }}</span>
        </button>
      </div>

      <div class="gx-as__toolbar">
        <label class="gx-as__checkall">
          <input type="checkbox" :checked="allChecked" :indeterminate.prop="checkListIndeterminate" @change="bindCheckAll($event.target.checked)" />
          <span class="gx-as__checkall-box">
            <svg v-if="allChecked" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
            <span v-else-if="checkListIndeterminate" class="gx-as__checkall-dash"></span>
          </span>
        </label>
        <div class="gx-as__divider"></div>
        <span class="gx-as__batch-label">共 {{ pageData.total }} 条</span>
        <div class="gx-as__divider"></div>
        <button class="gx-as__btn gx-as__btn--pink" :disabled="batchOperateSubmitting" @click="bindBatchAccept(BATCH_REFUND)">
          {{ batchOperateSubmitting ? '处理中...' : '批量同意退款' }}
        </button>
        <button class="gx-as__btn gx-as__btn--plain" :disabled="batchOperateSubmitting" @click="bindBatchAccept(BATCH_RETURN)">
          {{ batchOperateSubmitting ? '处理中...' : '批量同意退货' }}
        </button>
      </div>

      <div class="gx-table gx-as__table">
        <table>
          <thead>
            <tr>
              <th style="width: 32px;box-sizing: border-box;"></th>
              <th>商品信息</th>
              <th>金额</th>
              <th>件数</th>
              <th>售后状态</th>
              <th>原因</th>
              <th>1688售后信息</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in list" :key="item.id || index">
              <td>
                <span class="gx-as__check" :class="{ 'gx-as__check--on': checkList.includes(item.id) }" @click="toggleOne(item.id)">
                  <svg v-if="checkList.includes(item.id)" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                </span>
              </td>
              <td>
                <div class="gx-as__col-info">
                  <div class="gx-as__info-lines">
                    <p class="gx-as__info-line">
                      <span class="gx-as__info-k">微店单号：</span>
                      <span class="gx-as__oid">{{ isHideOrderInfo ? '************' : dash(item.wx_order_id) }}</span>
                      <i v-if="item.wx_order_id" class="gx-as__copy" @click="bindCopy(item.wx_order_id)">⧉</i>
                    </p>
                    <p class="gx-as__info-line">
                      <span v-if="shopName(item)" class="gx-as__shop">{{ isHideOrderInfo ? '************' : shopName(item) }}</span>
                      <span v-else class="gx-as__ph">--</span>
                    </p>
                    <p class="gx-as__info-line">
                      <span class="gx-as__info-k">售后单号：</span>
                      <span class="gx-as__oid">{{ dash(item.wx_after_sale_id) }}</span>
                      <i v-if="item.wx_after_sale_id" class="gx-as__copy" @click="bindCopy(item.wx_after_sale_id)">⧉</i>
                    </p>
                    <p class="gx-as__info-line">
                      <span class="gx-as__info-k">申请时间：</span>
                      <span class="gx-as__info-v">{{ dash(applyTimeText(item)) }}</span>
                    </p>
                  </div>
                  <div class="gx-as__goods">
                    <div class="gx-as__thumbs">
                      <div class="gx-as__thumb-cell">
                        <el-popover
                            placement="top"
                            :fallback-placements="[ 'top', 'right', 'left','bottom']"
                            width="350"
                            trigger="hover" :disabled="!productPic(item)">
                          <div class="popover-content">
                            <el-image :src="productPic(item)" fit="contain" style="width:100%;height: auto"></el-image>
                          </div>
                          <span slot="reference" class="gx-as__thumb gx-as__thumb--dd">
                            <img v-if="productPic(item)" :src="productPic(item)" alt="" @click="openImg(item)" />
                            <span v-else>🛍️</span>
                          </span>
                        </el-popover>
                      </div>
                    </div>
                    <div class="gx-as__con-box">
                      <p class="gx-as__product-title">{{ isHideOrderInfo ? '************' : dash(productName(item)) }}</p>
                      <p class="gx-as__dim gx-as__code-line">商品规格：{{ dash(productSpec(item)) }}</p>
                      <p v-if="exchangeSpecStr(item)" class="gx-as__dim gx-as__code-line gx-as__exchange-spec">换货规格：{{ dash(exchangeSpecStr(item)) }}</p>
                      <p class="gx-as__dim gx-as__code-line">商品ID：{{ dash(productId(item)) }}</p>
                    </div>
                  </div>
                  <div class="gx-as__remark-box">
                    <p class="gx-as__remark-line">
                      <span class="gx-as__remark-k">订单备注：</span>
                      <i v-if="orderRemarkFlagShow(item)" class="el-icon-s-flag" :style="{ color: orderRemarkFlagColor(item) }"></i>
                      <span class="gx-as__remark-val" :title="orderRemarkWordsDisplay(item)">{{ orderRemarkWordsDisplay(item) }}</span>
                      <a v-if="canEditOrderRemark(item)" href="javascript:;" class="gx-as__remark-link" @click="openMerchantNotes(item)">修改</a>
                    </p>
                  </div>
                </div>
              </td>
              <td class="td-top">
                <div class="gx-as__amount">
                  <p class="gx-as__amt-label">退款金额</p>
                  <p class="gx-as__refund-amt">{{ moneyText(item.refund_amount) }}</p>
                  <p v-if="platformDiscountReturnFen(item) > 0" class="gx-as__amt-pay">平台券退回</p>
                  <p v-if="platformDiscountReturnFen(item) > 0" class="gx-as__amt-pay-amt">{{ moneyText(platformDiscountReturnFen(item)) }}</p>
                  <p v-if="platformDiscountReturnFen(item) > 0" class="gx-as__amt-pay">有效退款</p>
                  <p v-if="platformDiscountReturnFen(item) > 0" class="gx-as__amt-pay-amt">{{ moneyText(effectiveRefundFen(item)) }}</p>
                  <p class="gx-as__amt-pay">订单实付</p>
                  <p class="gx-as__amt-pay-amt">{{ moneyText(orderPayAmount(item)) }}</p>
                </div>
              </td>
              <td>
                <div class="gx-as__count">
                  <p class="gx-as__count-num">×{{ dash(aftersaleNum(item)) }}</p>
                </div>
              </td>
              <td class="td-top">
                <div class="gx-as__status">
                  <p class="gx-as__status-text">{{ dash(statusText(item)) }}</p>
                  <p v-if="typeText(item)" class="gx-as__status-sub">{{ typeText(item) }}</p>
                  <p
                    v-if="Number(item.diff_deal_state) === 10 || Number(item.diff_deal_state) === 20"
                    class="gx-as__status-sub gx-as__diff-warn"
                  >{{ item.diff_deal_state_text || '处理不一致' }}</p>
                  <p v-if="diffDealManualHint(item)" class="gx-as__dim gx-as__diff-hint">{{ diffDealManualHint(item) }}</p>
                </div>
              </td>
              <td>
                <div class="gx-as__reason">{{ dash(item.reason_text || pickVal(item, ['text_part.reason_text'])) }}</div>
              </td>
              <td class="td-top">
                <div class="gx-as__status">
                  <div v-if="alibabaAftersaleList(item).length" class="gx-as__alibaba">
                    <div
                      v-for="(ali, aliIdx) in alibabaAftersaleList(item)"
                      :key="ali.id || ali.alibaba_order_id || aliIdx"
                      class="gx-as__remark-line--sep"
                      :class="{ 'gx-as__alibaba-group--sep': aliIdx > 0 }"
                    >
                      <p v-if="aliExchangePurchaseRoleText(ali)" class="gx-as__remark-line gx-as__exchange-purchase-role">
                        <span
                          class="gx-as__tag"
                          :class="aliExchangePurchaseRoleClass(ali)"
                        >{{ aliExchangePurchaseRoleText(ali) }}</span>
                      </p>
                      <div
                        v-if="aliProductVisible(ali)"
                        class="gx-as__goods"
                      >
                        <div
                          class="ali-pro-img"
                          :class="{ 'is-link': aliProductOfferLink(ali) }"
                          @click="openAlibabaOfferDetail(ali.product)"
                        >
                          <el-popover
                              placement="top"
                              :fallback-placements="[ 'top', 'right', 'left','bottom']"
                              width="350"
                              trigger="hover" :disabled="!ali?.product?.img">
                            <div class="popover-content">
                              <el-image :src="ali.product.img" fit="contain" style="width:100%;height: auto"></el-image>
                            </div>
                            <img slot="reference" v-if="ali.product && ali.product.img" class="gx-as__thumb gx-as__thumb--dd" :src="ali.product.img" alt="" />
                          </el-popover>
                        </div>
                        <div class="gx-as__con-box">
                          <p
                            class="gx-as__product-title"
                            :class="{ 'is-link': aliProductOfferLink(ali) }"
                            :title="aliProductName(ali)"
                            @click="openAlibabaOfferDetail(ali.product)"
                          >{{ aliProductName(ali) }}</p>
                          <p class="gx-as__dim" :title="aliProductSpec(ali)">{{ aliProductSpec(ali) }}</p>
                        </div>
                      </div>
                      <p class="gx-as__remark-line" :style="aliIdx === 0 ? 'margin-top: 8px;' : ''">
                        <span class="gx-as__remark-k">采购退款状态：</span>
                        <span class="gx-as__tag gx-as__tag--type ali-status-tag">{{ aliStatusText(ali) }}</span>
                      </p>
                      <p class="gx-as__remark-line">
                        <span class="gx-as__remark-k">退款金额：</span>
                        <span class="red">¥{{ formatAliAmount(ali.refund_amount) }}</span>
                      </p>
                      <p class="gx-as__remark-line">
                        <span class="gx-as__remark-k">售后单号：</span>
                        <template v-if="ali.refund_id">
                          <a
                            target="_blank"
                            class="gx-as__remark-link"
                            :href="'https://dispute.1688.com/refund/assureRefundDetail.htm?refundId=' + ali.refund_id"
                            @click.stop
                          >{{ ali.refund_id }}</a>
                          <i class="gx-as__copy" @click="bindCopy(String(ali.refund_id))">⧉</i>
                        </template>
                        <span v-else class="gx-as__ph">--</span>
                      </p>
                      <p class="gx-as__remark-line">
                        <span class="gx-as__remark-k">采购单号：</span>
                        <a
                          v-if="ali.alibaba_order_id"
                          target="_blank"
                          class="gx-as__remark-link"
                          :href="'https://air.1688.com/app/ctf-page/trade-order-detail/index.html?orderId=' + ali.alibaba_order_id"
                          @click.stop
                        >{{ ali.alibaba_order_id }}</a>
                        <span v-else class="gx-as__ph">--</span>
                      </p>
                      <p class="ali-ww">
                        <span class="gx-as__remark-k">上家旺旺：</span>
                        <span class="gx-as__oid">{{ aliWangwang(ali) }}</span>
                        <i
                          v-if="aliChatable(ali)"
                          class="el-icon-chat-dot-round ali-ww-icon"
                          style="cursor: pointer;margin-left: 8px;"
                          title="打开旺旺"
                          @click="openAlibabaWangwangChat(ali)"
                        />
                      </p>
                    </div>
                  </div>
                  <span v-else class="gx-as__ph">--</span>
                </div>
              </td>
              <td>
                <div class="gx-as__ops">
                  <button class="gx-as__op-btn" @click="goAftersaleDetail(item)">详情</button>
                  <button
                    v-if="canAccept(item)"
                    class="gx-as__op-btn"
                    :disabled="rowOpLoading === item.id"
                    @click="bindAccept(item)"
                  >{{ rowOpLoading === item.id ? '处理中' : '同意' }}</button>
                  <button
                    v-if="canReject(item)"
                    class="gx-as__op-btn"
                    :disabled="rowOpLoading === item.id"
                    @click="bindReject(item)"
                  >拒绝</button>
                </div>
              </td>
            </tr>
            <tr v-if="!list.length && !loading">
              <td :colspan="8">
                <div class="gx-as__empty">暂无数据</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style="padding: 10px 14px;background: rgb(245, 240, 232);">
        <Pagination
          :total="pageData.total"
          :page.sync="pageData.page"
          :limit.sync="pageData.limit"
          :page-sizes="[10, 20, 50, 100, 200, 300, 400]"
          layout="total, sizes, prev, pager, next, jumper"
          @pagination="getList(true, pageData.page)"
        />
      </div>
    </div>
    <gx-loading :show="loading" />

    <merchantNotesDialog
      :show="remarkDialog.show"
      :order-id="remarkDialog.orderId"
      :shop-id="remarkDialog.shopId"
      :wx-order-id="remarkDialog.wxOrderId"
      :init-notes="remarkDialog.notes"
      :init-tag-color="remarkDialog.tagColor"
      @close="remarkDialog.show = false"
      @complete="onMerchantNotesSaved"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import GxLoading from '../../components/newUi/GxLoading.vue'
import Pagination from '../../components/newUi/Pagination.vue'
import merchantNotesDialog from '../xdOrderList/components/merchant_notes/index.vue'
import gxLoading from '../../mixins/gxLoading'
import { getShopList } from '../../api/wxshop/order'
import {
  getAftersaleFilters,
  getAftersaleList,
  postAftersaleAccept,
  postAftersaleReject,
  postAftersaleBatchAccept
} from '../../api/wxshop/aftersale'

const BATCH_REFUND = 'refund'
const BATCH_RETURN = 'return_refund'

const DEFAULT_TABS = [
  { val: 0, text: '全部', count_num: 0 },
  { val: 10, text: '未发货退款待处理', count_num: 0 },
  { val: 20, text: '已发货仅退款待处理', count_num: 0 },
  { val: 30, text: '退货退款待处理', count_num: 0 },
  { val: 40, text: '换货待处理', count_num: 0 },
  { val: 50, text: '待商家收货', count_num: 0 },
  { val: 60, text: '已完结', count_num: 0 },
  { val: 70, text: '已关闭', count_num: 0 }
]

export default {
  name: 'WxAfterSalesListPage',
  components: { GxLoading, Pagination, merchantNotesDialog },
  mixins: [gxLoading],
  data() {
    return {
      BATCH_REFUND,
      BATCH_RETURN,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      searchData: {
        tab_value: 0,
        group_ids: [],
        shop_id: '',
        aftersale_type: '',
        aftersale_status: '',
        reason_text: '',
        product_id: '',
        wx_after_sale_id: '',
        wx_order_id: '',
        order_express_no: '',
        return_logistics_code: '',
        exchange_logistics_code: '',
        in_deadline: '',
        diff_deal_state: '',
        alibaba_refund_status: '',
        search_date: null
      },
      filterFields: {},
      groupList: [],
      arrShop: [],
      arrAftersaleType: [],
      arrStatus: [],
      arrApplyReason: [],
      inDeadlineOptions: [
        { val: 1, text: '是' },
        { val: 2, text: '否' }
      ],
      diffDealStateOptions: [
        { val: 0, text: '全部' },
        { val: 10, text: '1688同意/微店拒绝' },
        { val: 20, text: '1688拒绝/微店同意' },
        { val: 30, text: '处理一致' }
      ],
      arrAlibabaRefundStatus: [],
      arrTabList: DEFAULT_TABS,
      list: [],
      checkList: [],
      isHideOrderInfo: false,
      pageData: { limit: 20, page: 1, total: 0 },
      batchOperateSubmitting: false,
      rowOpLoading: null,
      remarkDialog: {
        show: false,
        orderId: 0,
        shopId: '',
        wxOrderId: '',
        notes: '',
        tagColor: 0
      }
    }
  },
  computed: {
    allChecked() {
      return this.list.length > 0 && this.checkList.length === this.list.length
    },
    checkListIndeterminate() {
      const n = this.list.length
      const c = this.checkList.length
      return n > 0 && c > 0 && c < n
    }
  },
  mounted() {
    const isHideInfo = localStorage.getItem('isHideInfo')
    if (isHideInfo == 1) this.isHideOrderInfo = true
  },
  created() {
    this.loadGroupList()
    this.loadShopList()
    this.loadFilters()
    this.getList()
  },
  methods: {
    ...mapActions({
      getShopBoardGroupList: 'shop_board/getShopBoardGroupList'
    }),
    loadGroupList() {
      this.getShopBoardGroupList({
        data: {},
        success: (res) => {
          if (res.code === 200) this.groupList = res.data || []
        }
      })
    },
    loadShopList() {
      const params = {}
      if (Array.isArray(this.searchData.group_ids) && this.searchData.group_ids.length) {
        params.group_ids = this.searchData.group_ids.join(',')
      }
      getShopList(params)
        .then((res) => {
          if (res.code === 200) {
            this.arrShop = (res.data && res.data.list) || []
          }
        })
        .catch(() => {})
    },
    onGroupChange() {
      // if (this.$store.state.login.user_level == 9 && this.searchData.group_ids && this.searchData.group_ids.length) {
      //   this.searchData.group_ids = []
      //   this.$message.error('普通会员无法使用分组')
      //   return
      // }
      this.loadShopList()
      this.loadFilters()
    },
    loadFilters() {
      const params = {}
      if (Array.isArray(this.searchData.group_ids) && this.searchData.group_ids.length) {
        params.group_ids = this.searchData.group_ids.join(',')
      }
      getAftersaleFilters(params)
        .then((res) => {
          if (res.code !== 200) return
          const data = res.data || {}
          this.filterFields = data.filter_fields || {}
          this.arrAftersaleType = data.aftersale_type || data.aftersale_types || []
          this.arrStatus = data.aftersale_status || data.status_list || []
          this.arrTabList = data.tab_list || DEFAULT_TABS
          this.arrApplyReason = Array.isArray(data.apply_reasons) ? data.apply_reasons : (data.arr_apply_reason || [])
          this.inDeadlineOptions = data.in_deadline_options || this.inDeadlineOptions
          this.diffDealStateOptions = data.diff_deal_states || this.diffDealStateOptions
          this.arrAlibabaRefundStatus = data.alibaba_refund_status || data.arr_alibaba_refund_status || []
          if (this.arrAftersaleType.length && !this.searchData.aftersale_type) {
            const current = this.arrAftersaleType[0]
            if (current.status_list) {
              this.arrStatus = current.status_list
            }
          }
        })
        .catch(() => {
          this.arrTabList = DEFAULT_TABS
        })
    },
    onTypeChange(val) {
      const item = this.arrAftersaleType.find((row) => String(row.val) === String(val))
      if (item && item.status_list) {
        this.arrStatus = item.status_list
      }
    },
    isFilterEnabled(field) {
      const meta = this.filterFields[field]
      if (!meta || meta.enabled === undefined) {
        return field === 'order_express_no' || field === 'alibaba_refund_status'
      }
      return !!meta.enabled
    },
    filterDisabledTitle(field) {
      if (this.isFilterEnabled(field)) return ''
      const meta = this.filterFields[field]
      if (meta && meta.label) return meta.label + '筛选待开发'
      return '该筛选条件待开发'
    },
    onTabChange(val) {
      this.searchData.tab_value = val
      this.pageData.page = 1
      this.checkList = []
      this.getList()
    },
    tabBadgeCount(tabItem) {
      if (!tabItem || Number(tabItem.val) === 70) return 0
      if (tabItem.count_num === undefined || tabItem.count_num === null || tabItem.count_num === '') return 0
      const n = parseInt(tabItem.count_num, 10)
      return Number.isFinite(n) && n > 0 ? n : 0
    },
    resetSearch() {
      this.searchData = {
        tab_value: 0,
        group_ids: [],
        shop_id: '',
        aftersale_type: '',
        aftersale_status: '',
        reason_text: '',
        product_id: '',
        wx_after_sale_id: '',
        wx_order_id: '',
        order_express_no: '',
        return_logistics_code: '',
        exchange_logistics_code: '',
        in_deadline: '',
        diff_deal_state: '',
        alibaba_refund_status: '',
        search_date: null
      }
      this.checkList = []
      this.loadShopList()
      this.loadFilters()
      this.getList()
    },
    buildListParams() {
      const param = {
        limit: this.pageData.limit,
        page: this.pageData.page,
        tab_value: this.searchData.tab_value
      }
      const fields = [
        'shop_id',
        'aftersale_type',
        'aftersale_status',
        'reason_text',
        'product_id',
        'wx_after_sale_id',
        'wx_order_id',
        'return_logistics_code',
        'exchange_logistics_code'
      ]
      fields.forEach((key) => {
        const v = this.searchData[key]
        if (v !== '' && v != null) param[key] = v
      })
      if (this.isFilterEnabled('order_express_no') && this.searchData.order_express_no !== '') {
        param.order_express_no = this.searchData.order_express_no
      }
      if (this.isFilterEnabled('in_deadline') && this.searchData.in_deadline !== '') {
        param.in_deadline = this.searchData.in_deadline
      }
      if (this.isFilterEnabled('diff_deal_state') && this.searchData.diff_deal_state !== '') {
        param.diff_deal_state = this.searchData.diff_deal_state
      }
      if (this.isFilterEnabled('alibaba_refund_status') && this.searchData.alibaba_refund_status !== '') {
        param.alibaba_refund_status = this.searchData.alibaba_refund_status
      }
      if (Array.isArray(this.searchData.group_ids) && this.searchData.group_ids.length) {
        param.group_ids = this.searchData.group_ids.join(',')
      }
      if (Array.isArray(this.searchData.search_date) && this.searchData.search_date.length === 2) {
        param.start_time = this.searchData.search_date[0]
        param.end_time = this.searchData.search_date[1]
      }
      return param
    },
    getList(showLoading, page) {
      if (page) this.pageData.page = page
      this.loadingStart()
      getAftersaleList(this.buildListParams())
        .then((res) => {
          this.loadingEnd()
          if (res.code !== 200) {
            this.$message({ message: res.message || res.msg || '获取列表失败', type: 'error' })
            return
          }
          const data = res.data || {}
          this.list = data.data || data.list || []
          this.pageData.total = data.total || 0
          if (Array.isArray(data.tab_list) && data.tab_list.length) {
            this.arrTabList = data.tab_list
          }
          const idSet = new Set(this.list.map((row) => row.id))
          this.checkList = this.checkList.filter((id) => idSet.has(id))
        })
        .catch((err) => {
          this.loadingEnd()
          const msg = (err && err.message) || '售后接口未就绪，请确认后端服务与数据表已部署'
          this.$message({ message: msg, type: 'warning' })
          this.list = []
          this.pageData.total = 0
        })
    },
    toggleOne(id) {
      if (id == null) return
      const idx = this.checkList.indexOf(id)
      if (idx > -1) this.checkList.splice(idx, 1)
      else this.checkList.push(id)
    },
    bindCheckAll(val) {
      this.checkList = val ? this.list.map((row) => row.id).filter((id) => id != null) : []
    },
    bindCopy(text) {
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('Copy')
      document.body.removeChild(input)
      this.$message({ message: '复制成功', type: 'success' })
    },
    goAftersaleDetail(row) {
      if (!row || !row.id) {
        this.$message({ message: '缺少售后记录 ID', type: 'warning' })
        return
      }
      this.$router.push({
        path: '/new_aftersales_workbench',
        query: { menu: 'wx-after-mag', id: row.id }
      })
    },
    bindAccept(row) {
      if (!row || !row.id || this.rowOpLoading) return
      const exchangeHint = row.exchange_second_accept_hint
      if (exchangeHint) {
        this.$alert(exchangeHint, '提示', { confirmButtonText: '知道了', type: 'info' })
        return
      }
      this.$confirm('确认同意该售后申请？系统将同步微信并自动向 1688 发起退款。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.rowOpLoading = row.id
          postAftersaleAccept({ id: row.id })
            .then((res) => {
              this.rowOpLoading = null
              if (res.code !== 200) {
                this.$message({ message: res.message || res.msg || '操作失败', type: 'error' })
                return
              }
              this.$message({ message: '操作成功', type: 'success' })
              this.getList(false)
            })
            .catch(() => {
              this.rowOpLoading = null
              this.$message({ message: '操作失败', type: 'error' })
            })
        })
        .catch(() => {})
    },
    bindReject(row) {
      if (!row || !row.id || this.rowOpLoading) return
      this.$prompt('请输入拒绝原因', '拒绝售后', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S+/,
        inputErrorMessage: '请填写拒绝原因'
      })
        .then(({ value }) => {
          this.rowOpLoading = row.id
          postAftersaleReject({ id: row.id, reason: value })
            .then((res) => {
              this.rowOpLoading = null
              if (res.code !== 200) {
                this.$message({ message: res.message || res.msg || '操作失败', type: 'error' })
                return
              }
              this.$message({ message: '已拒绝', type: 'success' })
              this.getList(false)
            })
            .catch(() => {
              this.rowOpLoading = null
              this.$message({ message: '操作失败', type: 'error' })
            })
        })
        .catch(() => {})
    },
    bindBatchAccept(handleType) {
      if (!this.checkList.length) {
        this.$message({ message: '请先勾选售后单', type: 'warning' })
        return
      }
      if (this.batchOperateSubmitting) return
      const title = handleType === BATCH_REFUND ? '批量同意退款' : '批量同意退货'
      this.$confirm(`确认对已选的 ${this.checkList.length} 条售后执行「${title}」？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action !== 'confirm') {
            done()
            return
          }
          instance.confirmButtonLoading = true
          instance.confirmButtonText = '处理中...'
          this.batchOperateSubmitting = true
          postAftersaleBatchAccept({ handle_type: handleType, ids: this.checkList })
            .then((res) => {
              this.batchOperateSubmitting = false
              instance.confirmButtonLoading = false
              done()
              if (res.code !== 200) {
                this.$message({ message: res.message || res.msg || '请求失败', type: 'error' })
                return
              }
              const d = res.data || {}
              const ok = Number(d.success_count) || 0
              const fail = Number(d.fail_count) || 0
              this.$message({
                message: `处理完成：成功 ${ok} 条，失败 ${fail} 条`,
                type: fail > 0 ? 'warning' : 'success'
              })
              this.checkList = []
              this.getList()
            })
            .catch(() => {
              this.batchOperateSubmitting = false
              instance.confirmButtonLoading = false
              instance.confirmButtonText = '确定'
              this.$message({ message: '批量操作失败', type: 'error' })
              done()
            })
        }
      }).catch(() => {})
    },
    canAccept(item) {
      return !!(item && item.can_accept)
    },
    canReject(item) {
      return !!(item && item.can_reject)
    },
    openImg(row) {
      const product = row.order_product || row.product || {}
      const pic = product.product_pic || product.thumb_img || product.img
      if (!pic) return
      const htm =
        '<img style="object-fit: cover;margin-right: 10px;max-height:70vh;" src="' +
        pic +
        '" alt="">' +
        '<div style="margin-top:10px;font-size:16px;">' +
        (product.spec_value || product.sku_name || '') +
        '</div>'
      this.$alert(htm, product.product_name || product.title || '商品', {
        dangerouslyUseHTMLString: true,
        showClose: false,
        confirmButtonText: '关闭',
        closeOnClickModal: true,
        customClass: 'zdy-message-box'
      })
    },
    pickVal(item, paths) {
      for (const p of paths) {
        const v = p.split('.').reduce((o, k) => (o == null ? o : o[k]), item)
        if (v != null && v !== '') return v
      }
      return ''
    },
    dash(v) {
      if (v === null || v === undefined) return '--'
      return String(v).trim() === '' ? '--' : v
    },
    fenToYuan(fen) {
      const n = Number(fen)
      if (!Number.isFinite(n)) return null
      return n / 100
    },
    moneyText(v) {
      if (v === null || v === undefined || String(v).trim() === '') return '--'
      const n = Number(v)
      if (!Number.isFinite(n)) return '¥' + v
      const yuan = this.fenToYuan(n)
      return '¥' + Number(yuan).toFixed(2)
    },
    platformDiscountReturnFen(item) {
      if (!item) return 0
      const n = Number(item.platform_discount_return_amount)
      return Number.isFinite(n) && n > 0 ? n : 0
    },
    effectiveRefundFen(item) {
      if (!item) return 0
      const eff = Number(item.effective_refund_amount)
      if (Number.isFinite(eff) && eff >= 0) return eff
      const refund = Number(item.refund_amount)
      const plat = this.platformDiscountReturnFen(item)
      if (!Number.isFinite(refund)) return 0
      return Math.max(0, refund - plat)
    },
    formatAliAmount(v) {
      const n = Number(v)
      if (!Number.isFinite(n)) return '0.00'
      return n.toFixed(2)
    },
    shopName(item) {
      return this.pickVal(item, ['shop.shop_name', 'shop_name', 'wx_shop.shop_name'])
    },
    productRow(item) {
      return item.order_product || item.product || {}
    },
    productPic(item) {
      const p = this.productRow(item)
      return p.product_pic || p.thumb_img || p.img || ''
    },
    productName(item) {
      const p = this.productRow(item)
      return p.product_name || p.title || ''
    },
    productSpec(item) {
      const p = this.productRow(item)
      return p.spec_value || p.sku_name || ''
    },
    exchangeSpecStr(item) {
      if (!item) return ''
      return item.exchange_product_spec_str
        || (item.order_product && item.order_product.exchange_product_spec_str)
        || ''
    },
    diffDealManualHint(item) {
      const st = Number(item && item.diff_deal_state)
      if (st !== 10 && st !== 20) return ''
      const list = this.alibabaAftersaleList(item)
      const parts = []
      list.forEach((ali) => {
        const rm = String(ali.step_remark || '').trim()
        if (rm) parts.push(rm)
      })
      if (parts.length) {
        return '1688说明：' + parts.join('；') + '（请人工处理）'
      }
      return '微信与1688处理结论不一致，请人工核对'
    },
    productId(item) {
      const p = this.productRow(item)
      return p.product_id || p.goods_id || ''
    },
    aftersaleNum(item) {
      return item.aftersale_num != null && item.aftersale_num !== '' ? item.aftersale_num : item.count || ''
    },
    orderPayAmount(item) {
      return this.pickVal(item, ['order_product.pay_amount', 'order.order_price', 'order_price'])
    },
    statusText(item) {
      return this.pickVal(item, ['text_part.aftersale_status_text', 'aftersale_status_text', 'status_text'])
    },
    typeText(item) {
      return this.pickVal(item, ['text_part.aftersale_type_text', 'aftersale_type_text', 'type_text'])
    },
    applyTimeText(item) {
      return item.apply_time || item.wx_apply_time || item.created_at
    },
    orderRemarkWordsDisplay(item) {
      const notes = item && (item.merchant_remark || item.merchant_notes)
      if (notes == null || String(notes).trim() === '') return '暂无'
      return String(notes)
    },
    orderRemarkFlagShow(item) {
      return !!(item && item.merchant_notes_tag_color_info)
    },
    orderRemarkFlagColor(item) {
      const info = item && item.merchant_notes_tag_color_info
      return (info && info.color) || '#c0c4cc'
    },
    canEditOrderRemark(item) {
      return !!(item && (item.order_id || item.wx_order_id))
    },
    openMerchantNotes(item) {
      if (!item) return
      this.remarkDialog = {
        show: true,
        orderId: Number(item.order_id) || 0,
        shopId: this.pickVal(item, ['shop.shop_id', 'shop_id']) || '',
        wxOrderId: item.wx_order_id || '',
        notes: item.merchant_remark || item.merchant_notes || '',
        tagColor: item.merchant_notes_tag_color != null ? item.merchant_notes_tag_color : 0
      }
    },
    onMerchantNotesSaved(data) {
      const orderId = data && data.order_id
      const wxOrderId = data && data.wx_order_id
      const row = this.list.find((item) => {
        if (orderId && Number(item.order_id) === Number(orderId)) return true
        if (wxOrderId && String(item.wx_order_id) === String(wxOrderId)) return true
        return false
      })
      if (!row) {
        this.getList(false)
        return
      }
      const notes = data.merchant_notes != null ? data.merchant_notes : data.merchant_remark
      this.$set(row, 'merchant_remark', notes || null)
      this.$set(row, 'merchant_notes', notes || null)
      this.$set(row, 'merchant_notes_tag_color', data.merchant_notes_tag_color)
      this.$set(row, 'merchant_notes_tag_color_info', data.merchant_notes_tag_color_info || null)
    },
    alibabaAftersaleList(item) {
      if (!item) return []
      if (Array.isArray(item.alibaba_aftersale_list) && item.alibaba_aftersale_list.length) {
        return item.alibaba_aftersale_list
      }
      if (item.alibaba_aftersale) return [item.alibaba_aftersale]
      return []
    },
    aliExchangePurchaseRoleText(ali) {
      if (!ali) return ''
      if (ali.exchange_purchase_role === 'old') {
        return ali.exchange_purchase_role_text || '旧采购单'
      }
      return ''
    },
    aliExchangePurchaseRoleClass(ali) {
      return ali && ali.exchange_purchase_role === 'old' ? 'gx-as__tag--exchange-old' : 'gx-as__tag--type'
    },
    aliStatusText(ali) {
      if (!ali) return '--'
      return ali.refund_status_text || ali.status_text || ali.refund_status || '--'
    },
    aliProductVisible(ali) {
      const p = ali && ali.product
      if (!p) return false
      return !!(p.img || p.name || p.sku_spec_value)
    },
    aliProductName(ali) {
      const p = ali && ali.product
      return (p && p.name) || '-'
    },
    aliProductSpec(ali) {
      const p = ali && ali.product
      return (p && p.sku_spec_value) || '-'
    },
    aliProductOfferLink(ali) {
      const p = ali && ali.product
      return !!(p && (p.offer_url || p.offer_id))
    },
    aliWangwang(ali) {
      return (ali && ali.wangwang_account) || '--'
    },
    aliChatable(ali) {
      if (!ali) return false
      return !!(ali.wangwang_account || ali.wangwang_chat_url)
    },
    openAlibabaWangwangChat(ali) {
      const row = ali || {}
      const url = String(row.wangwang_chat_url || '').trim()
      if (url) {
        window.open(url, '_blank')
        return
      }
      const account = String(row.wangwang_account || '').trim()
      if (!account) {
        this.$message({ message: '暂无上家旺旺', type: 'warning' })
        return
      }
      const wangwangId = account.replace(/^cnalichn/i, '')
      const touid = encodeURIComponent('cnalichn' + wangwangId)
      window.open(
        `https://air.1688.com/app/ocms-fusion-components-1688/def_cbu_web_im/index.html?&touid=${touid}&siteid=cnalichn&status=1&portalId=&gid=&offerId=&itemsId=&spmid=a261y.7663282.0#/`,
        '_blank'
      )
    },
    openAlibabaOfferDetail(product) {
      const p = product || {}
      let url = String(p.offer_url || '').trim()
      if (!url && p.offer_id) {
        const id = String(p.offer_id).trim()
        url = `https://detail.1688.com/offer/${id}.html?offerId=${id}`
      }
      if (!url) {
        this.$message({ message: '暂无1688商品链接', type: 'warning' })
        return
      }
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../styles/gx-after-sales-list.scss';

.gx-as__filter-btn--primary {
  background: #c8443c;
  border-color: #c8443c;
  color: #fff;
}
.gx-as__filter-btn--primary:hover {
  background: #b83a33;
  border-color: #b83a33;
}
.gx-as__exchange-spec {
  color: #1677ff;
}
.gx-as__exchange-purchase-role {
  margin: 0 0 6px;
}
.gx-as__tag--exchange-old {
  background: #fff7e6;
  color: #d46b08;
  border: 1px solid #ffd591;
}
.gx-as__alibaba-group--sep {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #e8e8e8;
}
.gx-as__alibaba .ali-pro-img {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  overflow: hidden;
  background: #f8f8f8;
  flex-shrink: 0;
}
.gx-as__alibaba .ali-pro-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.gx-as__alibaba .is-link {
  cursor: pointer;
}
.gx-as__alibaba .ali-ww {
  margin: 0;
  font-size: 12px;
  line-height: 1.7;
}
.gx-as__alibaba .ali-ww-icon {
  color: #409eff;
  font-size: 14px;
  vertical-align: middle;
}
.gx-as__diff-warn {
  color: #e6a23c;
  font-weight: 600;
}
.gx-as__diff-hint {
  color: #909399;
  margin-top: 4px;
  line-height: 1.5;
}
</style>
